<template>
  <div class="counter-container">
    <span>{{ label }}</span> : <span>{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      value: ''
    }
  }
}
</script>

<style scoped>
  .counter-container {
    margin: 20px 0px 10px 30px;
  }
</style>
